import React from "react";
import { Avatar } from "@material-ui/core";
import { useSongThumbnailUrl } from "hooks/useSongThumbnailUrl";

// Thin wrapper so each list row gets its own component instance (and
// so its own useSongThumbnailUrl call) - a plain function called from
// inside a .map() would violate the rules of hooks, since it'd run a
// variable number of times within the same parent render instead of
// once per instance.
export default ({ song, className }) => (
  <Avatar src={useSongThumbnailUrl(song)} className={className} />
);
